/**
 * quota-i18n — default i18n instance for the shared quota components.
 *
 * Every component also takes a `t` prop so hosts that already own an I18n
 * instance (Drive, Email) can pass theirs in instead.
 */

import { I18n } from 'i18n-js'
import locales from '../../../locales.json'

const i18n = new I18n(locales)
i18n.locale = document.querySelector("meta[name='locale']")?.content || 'hu'

export function t(key, opts) {
  return i18n.t(key, opts)
}

/** Human metric name, falling back to the raw metric key when untranslated. */
export function metricLabel(metric, translate = t) {
  if (!metric) return ''
  return translate(`quotas.metrics.${metric}`, { defaultValue: String(metric).replace(/_/g, ' ') })
}

export default i18n
